import { Avatar, Dialog, DialogTitle, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, useTheme } from "@mui/material";
import GroupsIcon from '@mui/icons-material/Groups';
import { useState } from "react";
import { useOrganizationContext } from "../ContextProviders/OrganizationContext";
import { blue } from "@mui/material/colors";
import { getAvatar } from "../Reuseables/CustomAvatar";



export default function OrganizationDialog() {

  const [open, setOpen] = useState(false)
 const {organizations, activeOrganization, setActiveOrganization} = useOrganizationContext();

  const handleopen =()=> {
    setOpen(true)
  }

  const handleClose =() =>  {
    setOpen(false)
  }
    const theme = useTheme();


   
  return (
    <>
      <IconButton
        onClick={handleopen}
        sx={{
          p: "2px",
          width: 40,
          height: 40,
          background: (theme) =>
            `conic-gradient(${theme.palette.primary.light}, ${theme.palette.warning.light}, ${theme.palette.primary.light})`,
  
        }}

      >
        <Avatar
          sx={{
            backgroundColor:
              theme.palette.mode === "light"
                ? theme.palette.primary.main
                : null,
          }}
        >
          <GroupsIcon />
        </Avatar>
      </IconButton>
      <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Switch organization</DialogTitle>
      <List sx={{ pt: 0 }}>
        {organizations.map((org) => (
          <ListItem disablePadding key={org.id} >
            <ListItemButton onClick={() => {setActiveOrganization(org); handleClose()}} selected={org.id === activeOrganization.id}>
              <ListItemAvatar>
                {org.badgeLogo ? <Avatar src={org.badgeLogo} sx={{width: 36, height: 36}}/> :getAvatar(org.name, 36,36) }
  
              </ListItemAvatar>
              <ListItemText primary={org.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Dialog>
    </>
  );
}

